import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinthane() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Thane',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Thane',
    headingDescription: 'Pune Corporate Cars India Private Limited offers reliable and professional Corporate Cab Services in Thane, catering to the transportation needs of corporate offices, business parks, and industrial areas in the region. Our fleet of premium sedans, SUVs, and executive vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, client visits, or VIP movement, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental packages, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Thane.',

    top: 'Top Places to Visit in Thane with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Upvan Lake",
    "description": "Upvan Lake is one of Thane’s most beautiful and peaceful waterfront locations, surrounded by greenery and a stunning view of the Yeoor Hills. It is a popular leisure space for morning walks, jogging, cycling, and photography. In the evenings, the lake lights up with food stalls, couples, families, and local artists enjoying the fresh breeze. The lake is also known for hosting the annual Sanskruti Arts Festival, where music, dance, and cultural performances turn the entire lakeside into a vibrant celebration of Thane’s local art scene."
  },
  {
    "title": "Yeoor Hills",
    "description": "Part of the Sanjay Gandhi National Park, Yeoor Hills offers a perfect nature escape with dense forests, clean air, trekking routes, butterflies, birds, and small streams during monsoons. Many hikers visit early in the morning to experience the quiet, misty trails and panoramic views. The area also has tribal settlements, giving visitors a glimpse into the natural, simple lifestyle that still survives next to the urban sprawl."
  },
  {
    "title": "Talao Pali (Masunda Lake)",
    "description": "Located in the heart of Thane City, Talao Pali is a lively lakeside spot with boating, evening strolls, children’s play areas, local snack vendors, and a large Ganesh temple nearby. The lake’s reflection of the city lights and the surrounding nightlife make it a favorite evening hangout. Historically, it has been one of the central gathering spots of Thane and continues to be a core part of the city’s day-to-day social life."
  },
  {
    "title": "Kopineshwar Temple",
    "description": "One of the oldest and most significant Shiva temples in the region, Kopineshwar Temple features traditional architecture and a serene atmosphere that attracts devotees year-round. Said to date back more than 800 years, the temple has religious and historical importance in Thane’s heritage. During festivals like Maha Shivratri, it becomes a hub of elaborate rituals, cultural energy, and traditional festivities."
  },
  {
    "title": "Suraj Water Park",
    "description": "Suraj Water Park is a popular family destination featuring thrilling water slides, wave pools, children’s play zones, themed rides, and artificial waterfalls. Spread across a large area, the park is designed with colorful sculptures and fun attractions that make it ideal for school picnics, weekend outings, and summer vacations. It has won multiple awards for tourism and entertainment."
  },
  {
    "title": "Kelva Beach",
    "description": "Located a little outside the main city, Kelva Beach is a long, clean shoreline lined with palm trees, fishing boats, and quiet villages. It is popular for weekend getaways, beach picnics, sunsets, and simple seafood lunches from local vendors. Visitors can also explore nearby points like the Kelva Fort and Shitladevi Temple, making it a scenic and relaxing coastal escape from urban life."
  },
  {
    "title": "Ghodbunder Fort",
    "description": "Built in the 18th century by Portuguese forces, Ghodbunder Fort is an impressive heritage ruin located along the Vasai Creek. Though partially weathered, visitors can still see the old stone walls, bastions, watchtowers, and panoramic river views. The fort has seen multiple rulers — Portuguese, Marathas, and British — making it a historical attraction rich in stories of changing military power and trade routes around Mumbai and Thane."
  },
  {
    "title": "Ovalekar Wadi Butterfly Garden",
    "description": "Ovalekar Wadi Butterfly Garden is a privately developed natural habitat where over 130 species of butterflies can be seen fluttering across flowering plants and natural jungle patches. Guided tours educate visitors about life cycles, conservation, and the ecological importance of butterflies. It is a favorite weekend learning destination for students, families, photographers, and nature lovers."
  },
  {
    "title": "Thane Creek Flamingo Sanctuary",
    "description": "One of India’s most famous urban flamingo habitats, the Thane Creek Flamingo Sanctuary becomes a massive pink carpet during migratory season. Visitors can take boat safaris to see thousands of flamingos, mudskippers, crabs, and other coastal wildlife up close. Bird lovers and photographers flock here from across India to capture dramatic wildlife moments against the industrial skyline."
  },
  {
    "title": "Viviana Mall",
    "description": "Viviana Mall is one of the biggest lifestyle and entertainment malls in Thane, featuring national and international retail brands, multiplex cinema halls, dining courts, game zones, and regular live events. With wide walkways, modern design, and accessibility features, it has become a central shopping and leisure destination for families, professionals, and students."
  }
],


"services": [
{
"name": "Thane Corporate Cabs",
"description": "Thane Corporate Cabs provides professional taxi services for corporate employees, office staff, and business executives. The service includes well-maintained sedans and SUVs, trained drivers, GPS-enabled vehicles, and structured routes to ensure safe, comfortable, and punctual commuting across Thane."
},
{
"name": "Employee Pick Drop Thane",
"description": "Employee Pick Drop Thane offers reliable and structured pickup and drop services for corporate and industrial employees. With trained drivers, GPS monitoring, multi-shift scheduling, and optimized routes, the service ensures smooth, safe, and timely daily commutes for staff in and around Thane."
},
{
"name": "Company Cab Thane",
"description": "Company Cab Thane delivers dedicated corporate cab solutions for office and industrial staff. The service includes well-maintained vehicles, professional chauffeurs, GPS tracking, and structured daily schedules to provide efficient, comfortable, and reliable employee transport."
},
{
"name": "Business Taxi Thane",
"description": "Business Taxi Thane offers premium taxi services for corporate executives, business trips, and client visits. The service features trained drivers, comfortable vehicles, GPS-enabled monitoring, and timely pickups to ensure a professional and hassle-free commuting experience."
},
{
"name": "Thane Staff Shuttle",
"description": "Thane Staff Shuttle provides multi-passenger shuttle services for corporate offices, factories, and industrial units. The service emphasizes safe, organized, and punctual transportation with trained drivers, GPS-enabled vehicles, and optimized multi-shift routes for seamless employee mobility."
},
{
"name": "Affordable Corporate Cabs Thane",
"description": "Affordable Corporate Cabs Thane offers cost-effective corporate transportation for office staff and industrial employees. The service ensures reliable pickups, professional drivers, GPS monitoring, and well-maintained vehicles, providing budget-friendly and safe commuting solutions."
},
{
"name": "Monthly Cab Hire Thane",
"description": "Monthly Cab Hire Thane provides long-term cab rental solutions for companies requiring consistent employee transportation. The service includes fixed monthly plans, structured routes, trained chauffeurs, and GPS-enabled vehicles to ensure dependable daily commuting for staff."
},
{
"name": "Office Commute Thane",
"description": "Office Commute Thane specializes in daily transportation for corporate employees, IT staff, and industrial workers. With optimized routes, punctual pickups, trained drivers, and comfortable vehicles, the service ensures stress-free, reliable, and safe commuting across Thane."
},
{
"name": "Corporate Fleet Thane",
"description": "Corporate Fleet Thane provides fully managed corporate fleet solutions, including sedans, SUVs, and multi-passenger vehicles. The service ensures vehicle maintenance, driver management, GPS tracking, and route optimization to deliver seamless and efficient daily commuting for organizations."
},
{
"name": "Worker Transport Thane",
"description": "Worker Transport Thane delivers structured and safe transportation for industrial and factory employees. The service includes multi-shift support, trained drivers, GPS tracking, and comfortable vehicles, ensuring timely and organized transport for daily worker commuting."
},
{
"name": "Thane Industrial Cab Service",
"description": "Thane Industrial Cab Service offers specialized transport solutions for factory and industrial staff. The service provides dedicated vehicles, professional drivers, GPS-enabled monitoring, and well-planned multi-shift routes to ensure safe, punctual, and efficient worker commuting."
},
{
"name": "IT Employee Cabs Thane",
"description": "IT Employee Cabs Thane delivers reliable transportation for IT park staff and corporate employees. The service includes structured routes, trained chauffeurs, GPS-enabled vehicles, and comfortable seating to ensure smooth, safe, and timely daily commutes."
},
{
"name": "Best Corporate Cabs Thane",
"description": "Best Corporate Cabs Thane offers top-quality corporate transportation for office staff and executives. The service emphasizes safety, punctuality, trained drivers, GPS-enabled vehicles, and well-maintained fleets for seamless corporate commuting and business travel."
},
{
"name": "Thane Chauffeur Service",
"description": "Thane Chauffeur Service provides professionally driven vehicles for corporate executives, VIP clients, and office staff. The service focuses on comfort, safety, and punctuality, offering a premium commuting experience for daily office travel, business trips, and client visits."
},
{
"name": "Outstation Cab Thane",
"description": "Outstation Cab Thane delivers long-distance corporate and employee transportation services. The service features GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, punctual, and hassle-free travel for business trips and intercity commutes."
}
],

"tableData": [
["Thane Corporate Cabs", "Employee Pick Drop Thane"],
["Company Cab Thane", "Business Taxi Thane"],
["Thane Staff Shuttle", "Affordable Corporate Cabs Thane"],
["Monthly Cab Hire Thane", "Office Commute Thane"],
["Corporate Fleet Thane", "Worker Transport Thane"],
["Thane Industrial Cab Service", "IT Employee Cabs Thane"],
["Best Corporate Cabs Thane", "Thane Chauffeur Service"],
["Outstation Cab Thane", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Thane",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Thane, ensuring seamless and efficient transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping corporate staff reach their offices and business centers across Thane efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure journey for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate commuting."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Thane."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for scheduling, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Thane?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Thane.',
  },
  {
    question: 'What types of corporate cab services are available in Thane?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions.',
  },
  {
    question: 'Do you support daily employee commuting for Thane-based companies?',
    answer: 'Yes, we provide daily commute solutions with optimized routes, timely pickups, and customized shift schedules.',
  },
  {
    question: 'How can companies book corporate cab services in Thane?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Thane?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible and transparent pricing.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Thane?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Reliable corporate cab service in Thane. Pune Corporate Cars India Private Limited ensures punctual and safe employee transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priyanka Joshi',
    feedback: 'Excellent corporate cab service for our Thane office. Professional drivers and hassle-free commuting.',
    rating: 5,
  },
];


























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Thane",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-thane.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers professional corporate cab services in Thane, including employee pick-up and drop, office commute, business travel, monthly cab hires, industrial transport, and chauffeur-driven corporate fleet services. Ensure safe, reliable, and comfortable travel for employees and staff.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-thane"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Thane | Employee & Business Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers professional corporate cab services in Thane, including employee pick-up and drop, office commute, business travel, monthly cab hires, industrial transport, and chauffeur-driven corporate fleet services. Ensure safe, reliable, and comfortable travel for employees and staff."
  />

  <meta
    name="keywords"
    content="Thane Corporate Cabs, Employee Pick Drop Thane, Company Cab Thane, Business Taxi Thane, Thane Staff Shuttle, Affordable Corporate Cabs Thane, Monthly Cab Hire Thane, Office Commute Thane, Corporate Fleet Thane, Worker Transport Thane, Thane Industrial Cab Service, IT Employee Cabs Thane, Best Corporate Cabs Thane, Thane Chauffeur Service, Outstation Cab Thane"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinthane;